import React from "react";
import fieldPropTypes from "./field-prop-types";

const ImageField = ({ field, components: { Image, Loader } }) => {
  const altText =
    field.accessibility && field.accessibility.iconType === "option"
      ? field.accessibility.label
      : null;

  return (
    <Image
      url={field.url}
      image={field.image}
      size={field.size}
      align={field.align}
      components={{ Loader }}
      params={field.params}
      title={field.title}
      altText={altText}
      iconsSize={field.iconsSize}
    />
  );
};

ImageField.propTypes = fieldPropTypes;

export default ImageField;
